/**
 * SMS Grup Portal PDF Studio API adapter.
 * Bütün istekler, portalın diğer modülleri gibi src/api/axiosConfig.js
 * üzerinden gönderilir; /api prefix veya 3000 proxy KULLANILMAZ.
 * Token ve 401 yönlendirmesi ortak axiosConfig.js tarafından yönetilir.
 *
 * Dışarıdaki editör koduna uyum için response.json() / response.blob()
 * arayüzü korunur. İstekleri doğrudan Axios gönderir.
 */
import api from '../../../api/axiosConfig';

function getDetail(error) {
  const detail = error?.response?.data?.detail;
  if (error?.response?.status === 404 && (!detail || detail === 'Not Found')) {
    return 'PDF Studio endpoint bulunamadı (404). FastAPI routers/pdf_studio yönlendirmesini kontrol edin.';
  }
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((x) => x?.msg || String(x)).join(' | ');
  }
  if (detail && typeof detail === 'object') return JSON.stringify(detail);
  const status = error?.response?.status;
  if (status === 404) {
    return 'PDF Studio endpoint bulunamadı (404). FastAPI routers/pdf_studio yönlendirmesini kontrol edin.';
  }
  if (status === 401) return 'Portal oturumu geçersiz veya süresi dolmuş.';
  if (status === 403) return 'Bu PDF işlemine erişim yetkiniz yok.';
  if (error?.code === 'ERR_NETWORK') {
    return 'Backend bağlantısı kurulamadı. Portal axiosConfig.js baseURL ve FastAPI portunu kontrol edin.';
  }
  return error?.message || 'PDF Studio isteği başarısız.';
}

async function request(path, options = {}) {
  const {method = 'GET', body, headers, ...rest} = options;
  const requestPath = String(path || '');
  const download = /\/download(?:\?.*)?$/.test(requestPath);
  const effectiveHeaders = {...headers};
  // Multipart isteğinin boundary bilgisini Axios/tarayıcı belirler.
  if (body instanceof FormData) {
    for (const key of Object.keys(effectiveHeaders)) {
      if (key.toLowerCase() === 'content-type') delete effectiveHeaders[key];
    }
  }
  try {
    const response = await api.request({
      url: requestPath,
      method: method.toLowerCase(),
      data: body,
      headers: effectiveHeaders,
      responseType: download ? 'blob' : 'json',
      ...rest,
    });
    return {
      ok: true,
      status: response.status,
      json: async () => response.data,
      blob: async () => response.data instanceof Blob
        ? response.data
        : new Blob([response.data], {type: response.headers?.['content-type'] || 'application/pdf'}),
    };
  } catch (error) {
    throw new Error(getDetail(error));
  }
}

export const nativeRequest = (path, options = {}) => request(`/native-api${path}`, options);
export const nativeJson = async (path, options = {}) => (await nativeRequest(path, options)).json();
export const portalRequest = (path, options = {}) => request(`/pdf-studio${path}`, options);
export const portalJson = async (path, options = {}) => (await portalRequest(path, options)).json();

export async function closeNativeSession(id) {
  if (!id) return;
  try { await nativeRequest(`/documents/${id}`, {method: 'DELETE'}); }
  catch { /* Sunucu kaydı zaten kalıcı olarak tutulur; best-effort cleanup. */ }
}
